import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import NextImage from 'next/image';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';



export const Affordability = styled(Box)`
${({ theme: { breakpoints, colors } }) => `
margin-top:40px;
width: 100%;
color: ${colors.whites.white1};
flex-direction: column;
padding: 30px 0;
background-color: ${colors.greens.green5} !important;
position: relative;
height: auto;
p {font-size: 16px;}
display: flex;
z-index:1;

${breakpoints.up('md')} {
    h2 {font-size: 39px;}
    p {font-size: 24px;}
    z-index: unset;

};

&::before { 
    content: '';
    position: absolute;
    top: 0;
    right: 0 !important;
    background-color: ${colors.greens.green5} !important;
    right: -16px;
    width: 100vw;
    height: 100%;

    z-index: -1;

}

&::after { 
    content: '';
    position: absolute;
    top: 0;
    left: 0 !important;
    background-color: ${colors.greens.green5} !important;
    right: -16px;
    width: 100vw;
    height: 100%;

    z-index: -1;

}

${breakpoints.up('md')} {
    width: 75%;      

    &::after {
        background-color:  ${colors.whites.white1} !important;
    }
}

`}
`

export const AffordabilityButton = styled(Button) `
${({ theme: { breakpoints, colors } }) => `

margin-bottom: 20px;
border: 1px solid ${colors.whites.white1}};
color: ${colors.whites.white1};

padding: 10px 20px;

box-shadow: -1px 1px 6px  ${colors.whites.white1};
`}   
`;

export const MainContainer = styled(Box)`
${({ theme: { breakpoints } }) => `
 Display: flex; 
 `}
 `
    ;

export const AffordabilityContent = styled(Box)`
${({ theme: { breakpoints } }) => `
${breakpoints.up('md')} {  width: 60%; }

width: 100%;
`}`;